export default "<div class=\"col-lg-5 col-md-5 col-sm-8 footer\"><i class=\"fa\">@2020 NBCUniversal - MFR Build {{strBuildNumber}}</i> </div>\n\n"